import React, { FC } from 'react';
import { CreateArtView2 } from '../components';

export const CreateArtPage2: FC = () => {
  return <CreateArtView2 />;
};
